import * as React from 'react';

import { Colors } from 'theme/colors';
import { NakedIcon, VectorIconProps } from 'theme/icons';
import { FontSize } from 'theme/fonts';
import { Container } from 'theme/layout';
import { Bold, Regular, Light } from 'theme/text';

/**
 * Renders the option group component.
 *
 * @param props - Option group selector props.
 * @returns Options group selector.
 */
export function OptionGroup(props: OptionGroupProps) {
  const { accentColor, icon, children, title, description, subtitle } = props;

  return (
    <Container>
      {icon && (
        <Container marginBottom="15px" alignItems="center">
          <NakedIcon color={accentColor} {...icon} />
        </Container>
      )}
      {(subtitle || title) && (
        <Container marginBottom="15px">
          {subtitle && (
            <Regular textAlign="center" fontSize={FontSize.Medium}>
              {subtitle}
            </Regular>
          )}
          {title && (
            <Bold textAlign="center" color={Colors.thunder} fontSize={FontSize.Medium}>
              {title}
            </Bold>
          )}
        </Container>
      )}
      {children}
      {description && (
        <Container paddingLeft="5px" paddingRight="5px">
          <Light textAlign="center" color={Colors.darkGrey} fontSize={FontSize.Regular}>
            {description}
          </Light>
        </Container>
      )}
    </Container>
  );
}
/* Type definitions */
export interface OptionGroupProps {
  /** Descriptive message to display on the component */
  description?: React.ReactNode;
  /** Title to display on the component */
  title?: React.ReactNode;
  /** Primary color used to apply */
  accentColor: Colors;
  /** Any children to render */
  children?: React.ReactNode;
  /** Props for a fully configurable Vector icon */
  icon?: VectorIconProps;
  /** Descriptive message to display on the component */
  subtitle?: string;
}
